import type React from "react";
import type { AdminCargoDetailPageProps } from "../model";
import { CargoCreateInProgress } from "./in-progress";
import { CargoCreatePreview } from "./preview";

export const AdminCargoDetailPageUi: React.FC<AdminCargoDetailPageProps> = (
  props,
) => {
  if (props.previewValues) {
    return <CargoCreatePreview {...props} />;
  }
  return <CargoCreateInProgress {...props} />;
};
